import script from "./createFileName.vue?vue&type=script&lang=ts&setup=true"
export * from "./createFileName.vue?vue&type=script&lang=ts&setup=true"

import "./createFileName.vue?vue&type=style&index=0&id=e027243a&lang=less&scoped=true"
import "./createFileName.vue?vue&type=style&index=1&id=e027243a&lang=less"

import exportComponent from "/opt/teams-app/node_modules/.pnpm/vue-loader@17.0.0_webpack@5.74.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e027243a"]])

export default __exports__